import { Instagram, Phone, MapPin } from "lucide-react";
import { Link } from "react-router-dom";

const FOOTER_LINKS = [
  { label: "Home", path: "/" },
  { label: "Track", path: "/track" },
  { label: "Packages", path: "/packages" },
  { label: "Gallery", path: "/gallery" },
  { label: "Contact", path: "/contact" },
];

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#0a0a0a] border-t border-white/5">
      <div className="py-20 sm:py-28 text-center px-6">
        <h2 className="font-heading text-[#f5f5f5]/5 text-6xl sm:text-8xl lg:text-[10rem] uppercase leading-none select-none">
          Big Bang Speedway
        </h2>
         <div className="-mt-12 sm:-mt-16 lg:-mt-24 relative z-10">
           <Link
             to="/booking"
             data-testid="footer-book-tickets-button"
             className="inline-flex items-center px-12 py-4 bg-[#e8001d] hover:bg-[#cc0019] text-[#f5f5f5] font-heading text-2xl sm:text-3xl uppercase tracking-wider transition-all duration-300 hover:scale-105"
           >
             Book Tickets
           </Link>
         </div>
      </div>

      <div className="border-t border-white/5 py-10">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-start">
            <div>
              <Link to="/" className="font-heading text-[#f5f5f5] text-xl tracking-wider mb-3 block">
                BIG BANG <span className="text-[#e8001d]">SPEEDWAY</span>
              </Link>
              <p className="text-[#a3a3a3] text-sm leading-relaxed">
                Dehradun&apos;s Biggest Home of Speed &amp; Play.
                F1-style go-karting, paintball, arcade, café &amp; more.
              </p>
            </div>

            <div>
              <h4 className="text-[#f5f5f5] text-xs uppercase tracking-[0.2em] font-bold mb-4">Quick Links</h4>
              <div className="grid grid-cols-2 gap-2">
                {FOOTER_LINKS.map((link) => (
                  <Link
                    key={link.path}
                    to={link.path}
                    data-testid={`footer-link-${link.label.toLowerCase()}`}
                    className="text-[#a3a3a3] text-sm hover:text-[#e8001d] transition-colors"
                  >
                    {link.label}
                  </Link>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-[#f5f5f5] text-xs uppercase tracking-[0.2em] font-bold mb-4">Connect</h4>
              <div className="space-y-3">
                <div className="flex items-center gap-2 text-[#a3a3a3] text-sm">
                  <Phone size={14} className="text-[#e8001d]" />
                  <a href="tel:7518380496" className="hover:text-[#e8001d] transition-colors">+91 7518380496</a>
                </div>
                <div className="flex items-center gap-2 text-[#a3a3a3] text-sm">
                  <MapPin size={14} className="text-[#e8001d]" />
                  <span>Titan Road, Clement Town, Dehradun</span>
                </div>
                <div className="flex items-center gap-3 mt-4">
                  <a
                    data-testid="footer-instagram-link"
                    href="https://instagram.com/bigbangspeedway"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-10 h-10 border border-white/10 flex items-center justify-center text-[#a3a3a3] hover:text-[#e8001d] hover:border-[#e8001d]/50 transition-all duration-300"
                  >
                    <Instagram size={18} />
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-[#a3a3a3] text-xs">&copy; {new Date().getFullYear()} Big Bang Speedway. All Rights Reserved.</p>
            <p className="text-[#a3a3a3]/50 text-xs">Dehradun&apos;s Premier Go-Karting Destination</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
